/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/img-redundant-alt */
import React from "react";
import { Nav, Tab } from "react-bootstrap";
import Moment from "react-moment";
import {
  AMOUNTS_CAPITAL,
  COMMISSION_CAPITAL,
  CONFIRMATION_DATE_CAPITAL,
  CONFIRMATION_ID_CAPITAL,
  DATE_CAPITAL,
  DDD_DD_MMM_YYYY_HH_MM_SS_A,
  DEPOSITE_TYPE_CAPITAL,
  // EXPECTED_DELIVERY_DATE_CAPITAL,
  IP_CAPITAL,
  MM_DD_YY,
  RECEIVER_NAME_CAPITAL,
  SC_TRANSACTION_ID_CAPITAL,
  SC_TRANSACTION_TYPE_CAPITAL,
  SENDER_NAME_CAPITAL,
  STATUS_CAPITAL,
  TIME_ZONE,
  TRANSACTION_ID_CAPITAL
} from "../utils/const";
import NumberFormat from "react-number-format";
import { getStatusClass } from "../utils/utils";
import { NoRecordsFoundMessage } from "../../_metronic/_helpers";
import "moment-timezone";

export function RecentHistory({
  recentTransactionList,
  selectedTab,
  setSelectedTab
}) {
  // logger("recentTransactionList", recentTransactionList);
  const renderSenderName = (recentTransaction) => {
    let name = "";
    const { sender = {} } = recentTransaction || {};
    const { firstname = "", lastname = "" } = sender || {};

    if (!recentTransaction) {
      return;
    }
    if (!sender) {
      return;
    }
    if (firstname.length === 0 && lastname.length === 0) {
      return "-";
    }
    if (firstname) {
      name = name.concat(`${firstname}`);
    }
    if (lastname) {
      name = name.concat(` ${lastname}`);
    }

    return name;
  };

  const renderReceiverName = (recentTransaction) => {
    let name = "";
    const { receiver = {} } = recentTransaction || {};
    const { firstname = "", lastname = "" } = receiver || {};

    if (!recentTransaction) {
      return;
    }
    if (!receiver) {
      return;
    }
    if (firstname.length === 0 && lastname.length === 0) {
      return "-";
    }
    if (firstname) {
      name = name.concat(`${firstname}`);
    }
    if (lastname) {
      name = name.concat(` ${lastname}`);
    }

    return name;
  };

  const renderUserName = (recentWithdraw) => {
    const { sender } = recentWithdraw || [];
    const { firstname = "", lastname } = sender || {};
    let name = "";
    if (!recentWithdraw) {
      return;
    }
    if (firstname) {
      name = name.concat(`${firstname}`);
    }
    if (lastname) {
      name = name.concat(` ${lastname}`);
    }

    return name;
  };

  const renderBankName = (recentWithdraw) => {
    const { userBankId = {} } = recentWithdraw || [];
    const { bank = {} } = userBankId || {};
    const { bank_name = "-" } = bank || {};
    let name = "";
    if (!recentWithdraw) {
      return;
    }
    if (bank_name) {
      name = name.concat(`${bank_name}`);
    }
    return name;
  };

  const amountFormatter = (amount) => {
    return (
      <NumberFormat
        value={amount}
        displayType="text"
        thousandSeparator={true}
        prefix="$"
        decimalSeparator="."
        decimalScale={2}
        fixedDecimalScale={true}
      />
    );
  };

  const renderAmount = (recentWithdraw) => {
    const { amount = "0" } = recentWithdraw || [];
    return amountFormatter(amount);
  };

  const renderDate = (recentTransaction) => {
    const { createdAt = "-" } = recentTransaction || {};
    if (!createdAt) return "-";
    return (
      <Moment
        date={createdAt}
        format={DDD_DD_MMM_YYYY_HH_MM_SS_A}
        tz={TIME_ZONE}
      />
    );
  };

  const renderExpectedDeliveryDate = (recentTransaction) => {
    const { expecteddeliverydate, transactionStatusId } =
      recentTransaction || {};
    return (
      <>
        {transactionStatusId !== 1 ? (
          "-"
        ) : (
          <div>
            {`Pending Until `}
            <Moment
              date={expecteddeliverydate}
              format={MM_DD_YY}
              tz={TIME_ZONE}
            />
          </div>
        )}
      </>
    );
  };

  const renderConfirmationDate = (recentTransaction) => {
    const { confirmation_date = "-" } = recentTransaction || {};
    if (!confirmation_date) return "-";
    return (
      <Moment
        date={confirmation_date}
        format={DDD_DD_MMM_YYYY_HH_MM_SS_A}
        tz={TIME_ZONE}
      />
    );
  };

  const renderWithdrawDate = (recentTransaction) => {
    const { createdAt = "-" } = recentTransaction || {};
    if (!createdAt) return "-";
    return (
      <Moment
        date={createdAt}
        format={DDD_DD_MMM_YYYY_HH_MM_SS_A}
        tz={TIME_ZONE}
      />
    );
  };

  const renderDepositeType = (recentTransaction) => {
    const { deposite_type = {} } = recentTransaction || {};
    const { name = "-" } = deposite_type || {};
    if (!recentTransaction) {
      return;
    }
    let depositeTypeClass = "";
    depositeTypeClass =
      name && name === "Debit card"
        ? "depositeType-debitCard"
        : name && name === "Credit Card"
        ? "depositeType-credit"
        : name && name === "Wire Transfer"
        ? "depositeType-wire-transfer"
        : name && name === "ACH"
        ? "depositeType-ach"
        : name && name === "eCheck"
        ? "depositeType-eCheck"
        : name && name === "General"
        ? "depositeType-general"
        : "depositeType-general";
    return (
      <>
        <div className="row">
          <li className={`${depositeTypeClass}`}></li>
          {name}
        </div>
      </>
    );
  };

  const renderStatusType = (recentTransaction) => {
    const { transaction_status = {} } = recentTransaction;
    const { name = "-" } = transaction_status || {};

    if (!recentTransaction) {
      return;
    }

    return (
      <span className={`${getStatusClass(name)} status-color text-capitalize`}>
        {name}
      </span>
    );
  };

  const renderSelectedTab = (selectedTab) => {
    if (selectedTab === "first") return "Transactions";
    if (selectedTab === "second") return "Transactions by SC";
    if (selectedTab === "third") return "Accepted Payments";
    if (selectedTab === "forth") return "Rejected Payments";
    if (selectedTab === "fifth") return "Bank Transactions";
  };

  const renderNoDateFound = () => {
    return (
      <NoRecordsFoundMessage
        entities={recentTransactionList}
        errorMessage={"No recent transactions found!"}
      />
    );
  };

  return (
    <div
      className={`card card-custom mb-0 card-stretch gutter-b`}
      style={{ height: "auto" }}
    >
      <Tab.Container
        id="right-tabs-example"
        defaultActiveKey="first"
        activeKey={selectedTab}
        onSelect={(k) => setSelectedTab(k)}
      >
        {/* Head */}
        <div
          className="card-header border-0 py-5"
          style={{ justifyContent: "flex-end" }}
          alignRight
        >
          <Nav variant="pills">
            <Nav.Item>
              <Nav.Link
                className="btn font-weight-bolder  mobile-nav"
                eventKey="first"
              >
                Transactions
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link className="btn font-weight-bolder" eventKey="second">
                Transactions by SC
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link className="btn font-weight-bolder" eventKey="third">
                Accepted Payments
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link className="btn font-weight-bolder" eventKey="forth">
                Rejected Payments
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className="d-none">
              <Nav.Link className="btn font-weight-bolder" eventKey="fifth">
                Bank Transactions
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className="d-none">
              <Nav.Link className="btn font-weight-bolder" eventKey="sixth">
                Bank Confirm
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </div>
        <div className="card-header border-0 py-5">
          <h3 className="card-title align-items-center">
            <span className="card-label font-weight-bolder text-dark">
              Recent {renderSelectedTab(selectedTab)}
            </span>
          </h3>
        </div>
        {/* Body */}
        <div className="card-body pt-0 pb-3">
          {/* begin:tab content */}
          <Tab.Content>
            <Tab.Pane eventKey={selectedTab}>
              {recentTransactionList && recentTransactionList.length > 0 && (
                <div className="table-responsive">
                  <table className="table table-head-custom table-head-bg table-borderless table-vertical-center">
                    <thead>
                      <tr className="text-left text-uppercase">
                        <th style={{ minWidth: "110px" }}>
                          {TRANSACTION_ID_CAPITAL}
                        </th>
                        <th style={{ minWidth: "160px" }}>
                          {SENDER_NAME_CAPITAL}
                        </th>
                        <th style={{ minWidth: "160px" }}>
                          {RECEIVER_NAME_CAPITAL}
                        </th>
                        <th style={{ minWidth: "120px" }}>{AMOUNTS_CAPITAL}</th>
                        <th style={{ minWidth: "120px" }}>
                          {COMMISSION_CAPITAL}
                        </th>
                        <th style={{ maxWidth: "150px" }}>{DATE_CAPITAL}</th>
                        {/* <th style={{ maxWidth: "200px" }}>
                        {EXPECTED_DELIVERY_DATE_CAPITAL}
                      </th> */}
                        <th style={{ minWidth: "110px" }}>
                          {CONFIRMATION_ID_CAPITAL}
                        </th>
                        <th style={{ minWidth: "150px" }}>
                          {CONFIRMATION_DATE_CAPITAL}
                        </th>
                        <th style={{ minWidth: "110px" }}>
                          {SC_TRANSACTION_ID_CAPITAL}
                        </th>
                        <th style={{ minWidth: "110px" }}>
                          {SC_TRANSACTION_TYPE_CAPITAL}
                        </th>
                        <th style={{ minWidth: "110px" }}>
                          {DEPOSITE_TYPE_CAPITAL}
                        </th>
                        <th style={{ minWidth: "200px" }}>{STATUS_CAPITAL}</th>
                        <th style={{ minWidth: "100px" }}>{IP_CAPITAL}</th>
                      </tr>
                    </thead>
                    {recentTransactionList && recentTransactionList.length > 0 && (
                      <tbody>
                        {recentTransactionList.map(
                          (recentTransaction, index) => (
                            <tr key={index}>
                              <td>
                                <span className="text-dark d-block">
                                  {recentTransaction.id
                                    ? recentTransaction.id
                                    : "-"}
                                </span>
                              </td>
                              <td>
                                <span className="text-dark d-block text-capitalize">
                                  {renderSenderName(recentTransaction)}
                                  <br />{" "}
                                  {recentTransaction.sender.account_number
                                    ? ` - ${recentTransaction.sender.account_number}`
                                    : ""}
                                </span>
                              </td>
                              <td>
                                <span className="text-dark d-block text-capitalize">
                                  {renderReceiverName(recentTransaction)}
                                  <br />{" "}
                                  {recentTransaction.receiver.account_number
                                    ? ` - ${recentTransaction.receiver.account_number}`
                                    : ""}
                                </span>
                              </td>
                              <td>
                                <span className="text-dark d-block">
                                  {amountFormatter(recentTransaction.amount)}
                                </span>
                              </td>
                              <td>
                                <span className="text-dark d-block">
                                  {amountFormatter(
                                    recentTransaction.commission
                                  )}
                                </span>
                              </td>
                              <td>
                                <span className="text-dark d-block">
                                  {renderDate(recentTransaction)}
                                </span>
                              </td>
                              {/* <td>
                            <span className="text-dark d-block">
                              {renderExpectedDeliveryDate(recentTransaction)}
                            </span>
                          </td> */}
                              <td>
                                <span className="text-dark d-block">
                                  {recentTransaction.confirmation_id
                                    ? recentTransaction.confirmation_id
                                    : "-"}
                                </span>
                              </td>
                              <td>
                                <span className="text-dark d-block">
                                  {renderConfirmationDate(recentTransaction)}
                                </span>
                              </td>
                              <td>
                                <span className="text-dark d-block">
                                  {recentTransaction.sc_transactionId
                                    ? recentTransaction.sc_transactionId
                                    : "-"}
                                </span>
                              </td>
                              <td>
                                <span className="text-dark d-block">
                                  {recentTransaction.sc_type
                                    ? recentTransaction.sc_type
                                    : "-"}
                                </span>
                              </td>
                              <td>
                                <span className="text-dark d-block">
                                  {renderDepositeType(recentTransaction)}
                                </span>
                              </td>
                              <td>
                                <span className="text-dark d-block">
                                  {renderStatusType(recentTransaction)}
                                </span>
                              </td>
                              <td>
                                <span className="text-dark d-block">
                                  {recentTransaction.ip_country
                                    ? recentTransaction.ip_country
                                    : "-"}
                                </span>
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                    )}
                  </table>
                </div>
              )}

              {recentTransactionList &&
                recentTransactionList.length === 0 &&
                renderNoDateFound()}
            </Tab.Pane>
          </Tab.Content>
          {/* end:tab content */}
        </div>
      </Tab.Container>
    </div>
  );
}
